import { Box } from "@mui/material";
import { PageTitle } from "../../misc/PageTitle";
import { ResponsiveHashTabs } from "../../misc/ResponsiveHashTabs";
import { overviewCardStyle } from "../../misc/backofficeTheme";
import { DrivingSchoolExamsCalendar } from "./DrivingSchoolExamsCalendar";
import { DrivingSchoolExamsList } from "./DrivingSchoolExamsList";

export function DrivingSchoolExams() {
  const tabs = [
    {
      value: "",
      label: "Kalender",
      content: (
        <Box sx={{ ...overviewCardStyle, borderTopLeftRadius: { xs: "16px", sm: 0 }, p: 3, mt: 0 }}>
          <DrivingSchoolExamsCalendar />
        </Box>
      ),
    },
    {
      value: "list",
      label: "Liste",
      content: <DrivingSchoolExamsList />,
    },
  ];

  return (
    <div>
      <PageTitle documentTitle="Prüfungen">
        <h2 style={{ margin: 0, lineHeight: 0.83, marginBottom: 30, marginTop: 10 }}>Prüfungskalender</h2>
      </PageTitle>
      <ResponsiveHashTabs tabs={tabs} mobileSelectAriaLabel="Prüfungsansicht" />
    </div>
  );
}
